var React = require('react');
var styles = require('./Page1.scss');
var DropDown = require('./DropDown');
var RadioButtonList = require('./RadioButtonList');
var CheckBox = require('./CheckBox');
import Divider from './Divider';
import TextBox from './TextBox';
var PersonalData = require('./PersonalData');

var Page1 = React.createClass({
    getInitialState: function() {
        return {
            country: '',
            airport: '',
            direct: false,
            package: '',
            duration: '',
            accommodation: 'four',
            cheapAccommodation: '',
            allIn: 'no',
            allInWeek: 'both',
            kids: 'no',
            kidsWeek: 'both',
            seaView: false,
            transfer: false,
            insurance: false,
            surf: false,
            discount: null,
            showAirportSelect: false,
            showDirect: false,
            showBookYourOwn: false,
            showSurfAndTeam: false,
            fromAirport: '',
            enablePackage: false,
            enableDuration: false,
            enableAllIn: false,
            enableAllInWeek: false,
            enableAccommodation: false,
            enableSeaView: false,
            person: null,
            visible: this.props.visible
        }
    },
    getDefaultProps: function() {
        return {
            visible: true
        };
    },
    componentWillReceiveProps: function(nextProps) {
        this.setState({
            visible: nextProps.visible
        });
    },
    changeCountry: function(change) {
        this.refs[change.id].validate(change.newValue);
        var showAirport = change.newValue == 'sv';
        var enablePackage = false;
        var fromAirport = '';
        var showBookYourOwn = false;

        switch (change.newValue) {
            case 'sf':
                fromAirport = 'Flight from Helsinki';
                enablePackage = true;
                break;
            case 'no':
                fromAirport = 'Flight from Oslo';
                enablePackage = true;
                break;
            case 'dk':
                fromAirport = 'Flight from Copenhagen';
                enablePackage = true;
                break;
            case 'other':
                enablePackage = true;
                showBookYourOwn = true;
                break;
        }
        if (!showAirport) {
            this.setState({ airport: '' });
        }

        this.setState({
            country: change.newValue,
            showAirportSelect: showAirport,
            enablePackage: enablePackage,
            fromAirport: fromAirport,
            showDirect: false,
            direct: false,
            showBookYourOwn: showBookYourOwn
        }, function () {
            this.setChoices();
        });
    },
    changeAirport: function(change) {
        this.refs[change.id].validate(change.newValue);
        this.setState({
            airport: change.newValue,
            enablePackage: change.newValue != '',
            showDirect: change.newValue == 'sthlm',
            direct: false,
        }, function () {
            this.setChoices();
        });
    },
    changeDirect: function(change) {
        this.setState({
            direct: change.newValue,
        }, function () {
            this.setChoices();
        });
    },
    changePackage: function(change) {
        this.setState({
            package: change.newValue,
            enableAllIn: change.newValue == 'training' || change.newValue == 'beginner',
            enableKids: change.newValue == 'oldchild',
            enableAccommodation: change.newValue != 'child',
            accommodation: 'four',
            cheapAccommodation: '',
            allIn: 'no',
            kids: 'no',
            enableAllInWeek: false,
            enableKidsWeek: false,
            enableDuration: true,
            showSurfAndTeam: change.newValue.indexOf("child") < 0

        }, function () {
            this.setChoices();
        });
    },
    changeDuration: function(change) {
        this.setState({
            duration: change.newValue,
            enableAccommodation: true,
            enableSeaView: true,
            enableAllInWeek: change.newValue == 'timetwoweek' && this.state.allIn == 'yes',
            enableKidsWeek: change.newValue == 'timetwoweek' && this.state.kids == 'yes',
        }, function () {
            this.setChoices();
        });
    },
    changeAllIn: function(change) {
        this.setState({
            allIn: change.newValue,
            enableAllInWeek: change.newValue == 'yes' && this.state.duration == 'timetwoweek'
        }, function () {
            this.setChoices();
        });
    },
    changeAllInWeek: function(change) {
        this.setState({
            allInWeek: change.newValue
        }, function () {
            this.setChoices();
        });
    },
    changeKids: function(change) {
        this.setState({
            kids: change.newValue,
            enableKidsWeek: change.newValue == 'yes' && this.state.duration == 'timetwoweek'
        }, function () {
            this.setChoices();
        });
    },
    changeKidsWeek: function(change) {
        this.setState({
            kidsWeek: change.newValue
        }, function () {
            this.setChoices();
        });
    },
    changeAccommodation: function(change) {
        this.setState({
            accommodation: change.newValue,
            cheapAccommodation: '',
            enableSeaView: true,
        }, function () {
            this.setChoices();
        });
    },
    changeCheapAccommodation: function(change) {
        this.setState({
            accommodation: '',
            cheapAccommodation: change.newValue,
            enableSeaView: false,
            seaView: false,
        }, function () {
            this.setChoices();
        });
    },
    changeSeaView: function(change) {
        this.setState({
            seaView: change.newValue,
        }, function () {
            this.setChoices();
        });
    },
    changeTransfer: function(change) {
        this.setState({
            transfer: change.newValue,
        }, function () {
            this.setChoices();
        });
    },
    changeSurf: function(change) {
        this.setState({
            surf: change.newValue,
        }, function () {
            this.setChoices();
        });
    },
    changeInsurance: function(change) {
        this.setState({
            insurance: change.newValue,
        }, function () {
            this.setChoices();
        });
    },
    changeDiscount: function(change) {
        this.setState({
            discount: change.newValue
        }, function () {
            this.setChoices();
        });
    },

    render: function () {
        var originOptions = [
            { label: 'Choose country', value: '' },
            { label: 'Sweden', value: 'sv' },
            { label: 'Norway', value: 'no' },
            { label: 'Denmark', value: 'dk' },
            { label: 'Finland', value: 'sf' },
            { label: 'Other', value: 'other' }
        ];
        var airportOptions = [
            { label: 'Choose city', value: '' },
            { label: 'Stockholm', value: 'sthlm' },
            { label: 'Göteborg', value: 'gbg' },
            { label: 'Malmö (Flight from Copenhagen)', value: 'mo' }
        ];
        var trainingOptions = [
            { label: 'Participant in the training group', value: 'training' },
            { label: 'Participant in the basic course', value: 'beginner', modalHeader: 'Participant in the basic course', modalBody:'For those of you who just found the sport or never played beachvolley before' },
            { label: 'Accompanying adult', value: 'partner', modalHeader: 'Accompanying adult', modalBody: (
                <ul>
                    <li>Flight (travelers from Scandinavia)</li>
                    <li>7 nights stay at 5 star hotel (unless you choose apartment)</li>
                    <li>5-star breakfast buffet every day (unless you choose apartment)</li>
                    <li>5-star dinner buffet every day (unless you choose apartment)</li>
                    <li>3 free beach yoga sessions</li>
                    <li>use of the extended beach gym</li>
                    <li>use of the bigger and cozier beach lounge</li>
                    <li>After Beach with DJ on the beach every afternoon</li>
                    <li>Entrance to the farewell party</li>
                    <li>Pool party</li>
                    <li>Travel management & service provided by the BeachTravels staff</li>
                </ul>)},
            { label: 'Children 2-12 years', value: 'oldchild' },
            { label: 'Children under 2 years (transfer included)', value: 'child' }
        ];
        var durationOptions = [
            { label: '1 week April 21th-28th', value: 'timeoneweek' },
            { label: '1 week April 28th-May 5th', value: 'timeoneweek2' },
            { label: '2 weeks April 21th-May 5th', value: 'timetwoweek' }
        ];
        var allInOptions = [
            { label: 'Yes', value: 'yes' },
            { label: 'No', value: 'no' }
        ];
        var allInWeekOptions = [
            { label: 'Week 1', value: 'week1' },
            { label: 'Week 2', value: 'week2' },
            { label: 'Both', value: 'both' }
        ];
        var accommodationOptions = [
            { label: 'Quad or triple. The triple room consist of two queen size beds and one portable bed. (0 SEK/0 €)', value: 'four' },
            { label: 'Double (795 SEK/85 €)', value: 'two' },
            { label: 'Single (2795 SEK/295 €)', value: 'one' }
        ];
        var cheapAccommodationOptions = [
            { label: '3-4 persons (minus 1500 SEK/160€)', value: 'fourapart'},
            { label: '2 persons (minus 1200 SEK/125 €)', value: 'twoapart'},
        ];

        var containerClasses = [styles.wrapper, 'wrapper-640'];
        if (!this.state.visible) {
            containerClasses.push(styles.hidden);
        }

        var bookYourOwnText = this.state.showBookYourOwn ? (<div className="gap-top-20">You will have to book your own flight and we reduce the price by €300. Contact Rasmus through <a href="mailto:rasmus@beachvolley.se">rasmus@beachvolley.se</a> if you want us to help you find a solution with the flight.</div>) : null;
        return (
            <div className={containerClasses.join(' ')}>
                <div className={[styles.form, 'j-forms'].join(' ')}>
                    <div className={styles.content}>
                        <div className={styles.intro}>
                            <p>
                                The packages include flight round trip from Stockholm, Gothenburg, Malmö, Copenhagen or Oslo.
                                Included for participants in training group and basic course:
                            </p>
                            <ul>
                                <li>Flight (travelers from Scandinavia)</li>
                                <li>1 training session / day with our top coaches (Sun-Thurs)</li>
                                <li>7 nights stay at 5 star hotel (unless you choose apartment)</li>
                                <li>5-star breakfast buffet every day (unless you choose apartment)</li>
                                <li>5-star dinner buffet every day (unless you choose apartment)</li>
                                <li>4 free beach yoga sessions</li>
                                <li>Entry fee for our 6 tournaments</li>
                                <li>1 lecture by our top three world class coaches</li>
                                <li>Free use of courts and balls</li>
                                <li>Free use of the extended beach gym</li>
                                <li>Free babysitting during morning training (2-12 years)</li>
                                <li>Free use of the bigger and cozier beach lounge</li>
                                <li>After Beach with DJ on the beach every afternoon</li>
                                <li>Entrance to the farewell party</li>
                                <li>Pool party</li>
                                <li>Travel management & service provided by the BeachTravels staff</li>
                            </ul>
                            <p>
                                Do you want to go from a place other than the specified options? We will help you to find a solution.
                                Contact us through <a href="mailto:ask@beachtravels.se">ask@beachtravels.se</a> for more information.
                                <br/><br/>
                                Don't hesitate to contact us if you have any further questions.
                            </p>
                        </div>
                    </div>
                    <div className={styles.content}>
                        <Divider value={1} label="Travel package" enabled={false} />


                        <div className={styles.unit}>
                            <label className={styles.label}>I travel from</label>
                            <DropDown 
                                id='origin'
                                ref="origin"
                                options={originOptions}
                                value={this.state.country}
                                onChange={this.changeCountry}
                                visible={true}
                            />
                            {bookYourOwnText}
                            <div className="gap-top-20">{this.state.fromAirport}</div>
                        </div>

                        <div className={this.state.showAirportSelect ? styles.unit : [styles.unit, 'hidden'].join(' ')}>
                            <label className={styles.label}>from the city</label>
                            <DropDown
                                id='airport'
                                ref="airport"
                              options={airportOptions}
                              value={this.state.airport}
                              onChange={this.changeAirport}
                              visible={this.state.showAirportSelect}
                            />
                        </div>
                        <CheckBox id='direct'
                                  label='Direct flight guaranteed 500 SEK'
                                  enabled={true}
                                  value={this.state.direct}
                                  visible={this.state.showDirect}
                                  onChange={this.changeDirect}
                        />

                        <div className={[styles.unit, styles.package].join(' ')}>
                            <h4>I register as:</h4>
                            <RadioButtonList id='training'
                                             ref="training"
                                             options={trainingOptions}
                                             value={this.state.package}
                                             onChange={this.changePackage}
                                             group='package'
                                             enabled={this.state.enablePackage}
                            />

                            <h4 className={!this.state.enableAllIn ? 'hidden' : null}>All in (5 Extra training sessions/week 1495 SEK/159 €):</h4>
                            <RadioButtonList id='allin'
                                             options={allInOptions}
                                             group='extra'
                                             value={this.state.allIn}
                                             onChange={this.changeAllIn}
                                             enabled={this.state.enableAllIn}
                                             hidden={!this.state.enableAllIn} />

                            <h4 className={!this.state.enableAllInWeek ? 'hidden' : null}>Choose All in week(s):</h4>
                            <RadioButtonList id='allinweek'
                                             options={allInWeekOptions}
                                             group='allinweek'
                                             value={this.state.allInWeek}
                                             onChange={this.changeAllInWeek}
                                             enabled={this.state.enableAllInWeek}
                                             hidden={!this.state.enableAllInWeek} />

                            <h4 className={!this.state.enableKids ? 'hidden' : null}>Kids Beachvolley training (5 training sessions/week 795 SEK/85 €):</h4>
                            <RadioButtonList id='kids'
                                             options={allInOptions}
                                             group='kids'
                                             value={this.state.kids}
                                             onChange={this.changeKids}
                                             enabled={this.state.enableKids}
                                             hidden={!this.state.enableKids} />

                            <h4 className={!this.state.enableKidsWeek ? 'hidden' : null}>Choose Kids Beachvolley week(s):</h4>
                            <RadioButtonList id='kidsweek'
                                             options={allInWeekOptions}
                                             group='kidsweek'
                                             value={this.state.kidsWeek}
                                             onChange={this.changeKidsWeek}
                                             enabled={this.state.enableKidsWeek}
                                             hidden={!this.state.enableKidsWeek} />

                            <h4>Duration:</h4>
                            <RadioButtonList id='duration'
                                             ref="duration"
                                             options={durationOptions}
                                             value={this.state.duration}
                                             onChange={this.changeDuration}
                                             group='duration'
                                             enabled={this.state.enableDuration}
                            />

                        </div>
                        <Divider value={2} label="Accommodation" />
                        <div className={[styles.unit, styles.package].join(' ')}>
                            <h4>Choose room type (part of):</h4>

                            <h5>5 star hotel with breakfast and dinner included</h5>
                            <RadioButtonList id='accommodation'
                                             ref="accommodation"
                                             options={accommodationOptions}
                                             value={this.state.accommodation}
                                             onChange={this.changeAccommodation}
                                             group='accommodation'
                                             enabled={this.state.enableAccommodation}
                            />
                            <br/>
                            <CheckBox id='sea'
                                      value={this.state.seaView}
                                      label='Guaranteed ocean view (395 SEK/40 €)'
                                      enabled={this.state.enableSeaView}
                                      onChange={this.changeSeaView} />

                            <h5>Apartment with kitchen (Simple accommodation - 15 minutes walk along the board walk from the courts)</h5>
                            <RadioButtonList id='cheapAccommodation'
                                             options={cheapAccommodationOptions}
                                             value={this.state.cheapAccommodation}
                                             onChange={this.changeCheapAccommodation}
                                             group='cheapAccommodation'
                                             enabled={this.state.enableAccommodation}
                                             valid={this.state.accommodation != '' || this.state.cheapAccommodation != ''} />
                        </div>

                        <Divider value={3} label="Additional extras" />
                        <div className={[styles.unit, styles.package].join(' ')}>
                            <CheckBox id='transfer'
                                      label='Transfer from airport to the hotel round trip (300 SEK/35 €).'
                                      enabled={this.state.enableAccommodation}
                                      value={this.state.transfer}
                                      onChange={this.changeTransfer}
                                      infoBody='Only optional for travelers with flight included. For travelers with no flight included: Contact ask@beachtravels.se to see if we can match with any of our regular transfers.'/>
                            <CheckBox id='insurance'
                                      label='Cancellation insurance (300 SEK / 35 €)'
                                      enabled={this.state.enableAccommodation}
                                      value={this.state.insurance}
                                      onChange={this.changeInsurance}
                                      modalHeader={'Cancellation Insurance'}
                                      modalBody={(
                                      <div>
                                        <p>
                                            Praia da Rocha, we have our own cancellation insurance for 300 SEK per
                                            person, a medical certificate for acute illness is required, deductible
                                            amount to 500 SEK per person.
                                        </p>
                                        <p>
                                            No insurance is included in the trip. Traveler is required to ensure
                                            that he / she possesses adequate insurance cover.
                                        </p>
                                        <p>
                                            Shipping Costs for cancellation:
                                        </p>
                                        <ul>
                                            <li>-41 Days 500 SEK</li>
                                            <li>40-22 days 25%</li>
                                            <li>21-15 days 50%</li>
                                            <li>14-8 days 75%</li>
                                            <li>1 -7 days 100%</li>
                                        </ul>
                                        <p>
                                            Cancellation & Insurance is never refunded. Flight tickets are not
                                            refundable If there is no cancellation and the passenger is not present
                                            at the specified location and time of departure, or may he / she not
                                            participate or complete the journey because of he / she lacks before
                                            the trip necessary documents, valid passport, necessary notifications,
                                            etc., the organizer is entitled to credit to the total price for the trip.
                                            <br/><br/>
                                            For complete travel conditions, click here: <br/>
                                            <a href="http://beachtravels.se/important-to-know/">http://beachtravels.se/important-to-know/</a>
                                        </p>
                                      </div>
                                      )} />

                            <CheckBox id='surf'
                                      label='The surf trip (595 SEK/60 €)'
                                      enabled={this.state.enableAccommodation}
                                      visible={this.state.showSurfAndTeam}
                                      value={this.state.surf}
                                      onChange={this.changeSurf}
                                      infoBody='One afternoon road trip. The waves decide where we go in the Algarve. Included is the journey, about 2 hours surf lesson with instructor, board, wetsuit and insurance.'
                            />
                        </div>

                        <Divider value={4} label="Discount code" />
                        <div className={styles.unit}>
                            <TextBox id="discount" onChange={this.changeDiscount} placeholder="Enter code" enabled={this.state.enableAccommodation} />
                        </div>

                        <PersonalData enabled={false} onChange={this.handlePersonalDataChange} ref="person" />
                    </div>
                    <div className="footer">
                        <button onClick={this.submitView} className="primary-btn">Next</button>
                    </div>
                </div>
            </div>
        );
    },
    handlePersonalDataChange: function (change) {
        this.setState({ person: change.person });
    },
    setChoices: function() {
        var travelData = {
            country: this.state.country,
            airport: this.state.airport,
            direct: this.state.direct,
            package: this.state.package,
            allIn: this.state.allIn,
            allInWeek: this.state.allInWeek,
            duration: this.state.duration,
            accommodation: this.state.accommodation != '' ? this.state.accommodation : this.state.cheapAccommodation,
            seaView: this.state.seaView,
            transfer: this.state.transfer,
            insurance: this.state.insurance,
            surf: this.state.surf,
            discount: this.state.discount,
            kids: this.state.kids,
            kidsWeek: this.state.kidsWeek,
        };
        this.props.onChange({
            travelData: travelData,
            personData: this.state.person,
            visible: this.state.visible
        });
    },

    validate: function() {
        var isCountryValid = this.refs.origin.validate();
        var isAirportValid = (this.state.origin != 'sv' && isCountryValid) || this.refs.airport.validate();
        var isPackageValid = this.refs.training.validate();
        var isDurationValid = this.refs.duration.validate();
        var isPersonValid = this.refs.person.validate();

        var isValid = isCountryValid && isAirportValid && isPackageValid && isDurationValid && isPersonValid;
        return isValid;
    },
    submitView: function () {
        var isValid = this.validate();
        if (isValid) {
            this.setState({ visible: false }, function () {
                this.setChoices();
            });
        }

    }
});

module.exports = Page1;


// WEBPACK FOOTER //
// ./app/components/Page1.js